import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
} from '@angular/core';
import { PgppButtonIconComponent } from '../../shared/components/button/button';
import { ButtonTypeEnum } from '../../core/enums/button-type.enum';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.services';
import { GlobalMessageService } from '../../shared/services/global-message.service';

@Component({
  selector: 'app-login.component',
  imports: [PgppButtonIconComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent implements OnInit {
  router: Router = inject(Router);
  authService: AuthService = inject(AuthService);
  private globalMessageService = inject(GlobalMessageService);

  protected readonly ButtonType = ButtonTypeEnum;

  ngOnInit(): void {
    const message = this.authService.getPendingLoginMessage();
    if (message) {
      this.globalMessageService.addMessage({
        type: 'danger',
        message,
        onDismiss: () => this.authService.clearPendingLoginMessage(),
      });
    }

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }

  /**
   * Inicia o fluxo de login via Keycloak.
   * O Keycloak exibe a tela de login e faz brokering para Gov.br se configurado.
   */
  login(): void {
    this.authService.clearPendingLoginMessage();
    this.authService.loginRedirect();
  }

  abrirBuscaMedicoIntercambista(): void {
    this.router.navigate(['/busca-medico-intercambista']);
  }

  abrirValidacaoDeclaracao(): void {
    this.router.navigate(['/validacao-declaracao']);
  }
}
